<template>
  <div class="layout sale">
    <div class="top_nav sale">
      <menu-top-header-sale />
    </div>
    <router-view/>
  </div>
</template>
<script>
  import MenuTopHeaderSale from "../components/MenuTopHeaderSale";
  export default {
    components: {MenuTopHeaderSale},
    data() {
      return{
      }
    },
    mounted() {
    },
    methods: {
    }
  }
</script>
<style lang="stylus">
  .layout.sale{
    padding-top 97px;
  }
  .top_nav.sale{
    top: 0;
    position fixed;
    left 0;
    right 0;
    z-index 99;
  }
</style>
